import { combineReducers, createStore } from 'redux'

import dataModelsReducer from './features/data-models.redux'
import formReducer from './features/form.redux'
import storefrontReducer from './features/storefront.redux'
import transactionReducer from './features/transaction.redux'

const rootReducer = combineReducers({
  form: formReducer,
  dataModel: dataModelsReducer,
  storefront: storefrontReducer,
  transaction: transactionReducer
})

export type RootState = ReturnType<typeof rootReducer>

export const store = createStore(
  rootReducer,
  (window.__REDUX_DEVTOOLS_EXTENSION__?.() as any) || undefined
)
